import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import brand from 'dan-api/dummy/brand';
import PapperBlock from 'dan-components/PapperBlock/PapperBlock';
import Form from './Form';
import { withRouter } from 'react-router';
import { withCookies } from 'react-cookie';
import MySnackbar from '../../../components/Notification/StyledNotif';
import { connect } from 'react-redux';
import accessToken from '../../../utils/accessToken';
import { onFetchIndexQaCategoryAction } from "../../../redux/actions/qaCategory";
import NotFound from '../../NotFound/NotFound';
import { 
  onFetchCreateQaInformationAction,
  onFetchShowQaInformationAction,
  onFetchUpdateQaInformationAction,
  onFetchDeleteQaInformationAction,
  clearQaInformationAction
} from "../../../redux/actions/qaInformation";

function Edit(props) {
  const description = brand.desc;
  const { match } = props;

  const [notification, setNotification] = useState({
    openStyle: location.message ? true : false,
    message: location.message ? location.message : '',
    variant: location.message ? location.variant : 'info'
  });
  const [isNew, setIsNew] = useState(false);
  const [titleName, setTitleName] = useState("");
  const [qaCategories, setQaCategories] = useState([]);
  const internalValues = props.internalValues;
  const url = '/admin/qa_information/index'

  const displayNotification = (message , valiant ='error') => {
    setNotification({
      openStyle: true,
      message: message,
      variant: valiant
    });
  }

  // 詳細取得
  useEffect(() => {
    const url = props.path.split('/')
    if (url[url.length - 1] === 'new') {
      setIsNew(true)
      setTitleName("QA情報登録")
      props.clearQaInformation()
    } else {
      fetchForm()
      setTitleName("QA情報詳細")
    }
    fetchQaCategory()
  }, []);

  const fetchQaCategory = values => {
    props.onFetchIndexQaCategory({
      accessToken: accessToken(props),
      onSuccess: data => {
        let qaCategoryData = data.data;
        setQaCategories(qaCategoryData);
        qaCategoryData.length === 0 && displayNotification("QAカテゴリ情報を登録してください")
      },
      onErrorWithNotice: error => {
        displayNotification("QAカテゴリ情報を取得できませんでした")
      }
    })
  };

  const fetchForm = values => {
    props.onFetchShowQaInformation({
      accessToken: accessToken(props),
      data: {id: match.params.id},
      onErrorWithNotice: error => {
        displayNotification("詳細情報を取得できませんでした")
      }
    })
  };
  
  // 登録
  const newForm = values => {
    // let dataValues = values
    props.onFetchCreateQaInformation({
      accessToken: accessToken(props),
      data: values,
      onSuccess: async data => {
        props.history.push({ pathname: url, message: "登録が完了しました", variant: 'success'});
      },
      onErrorWithNotice: error => {
        displayNotification(error)
      }
    })
  };

  // 更新
  const editForm = values => {
    let dataValues = values
    dataValues.id = match.params.id
    props.onFetchUpdateQaInformation({
      accessToken: accessToken(props),
      data: dataValues,
      onSuccess: async data => {
        displayNotification("更新が完了しました", 'success')
      },
      onErrorWithNotice: error => {
        displayNotification(error)
      }
    })
  };

  // 削除
  const deleteForm = values => {
    props.onFetchDeleteQaInformation({
      accessToken: accessToken(props),
      data: {id: match.params.id},
      onSuccess: async data => {
        props.history.push({ pathname: url, message: "QA情報を削除しました", variant: 'success'});
      },
      onErrorWithNotice: error => {
        displayNotification("削除できませんでした")
      }
    })
  };
  
  return (
    <React.Fragment>
      {internalValues.role === 'company' ? <NotFound /> :
        <div>
          <Helmet>
            <title>{brand.name + " - " + titleName}</title>
          </Helmet>
          <PapperBlock title={titleName} whiteBg icon="ios-person-outline" desc="">
            <Form onSubmit={(values) => isNew ? newForm(values) : editForm(values)} deleteForm={deleteForm} internalValues={internalValues} url={url} action={isNew} qaCategories={qaCategories}/>
          </PapperBlock>
          <MySnackbar onClose={() => setNotification({...notification, openStyle: false})} notification={notification} />
        </div>
      }
    </React.Fragment>
  );
}

const mapStateToProps = state => {
  return {
    qaInformationData: state.getIn(['qaInformationReducers', 'qaInformationData']),
    loadingQaInformationCreate: state.getIn(['qaInformationReducers', 'loadingQaInformationCreate']),
    loadingQaInformationShow: state.getIn(['qaInformationserReducers', 'loadingQaInformationShow']),
    loadingQaInformationData: state.getIn(['qaInformationserReducers', 'loadingQaInformationData'])
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchCreateQaInformation: data => {
      dispatch(onFetchCreateQaInformationAction(data));
    },
    onFetchShowQaInformation: data => {
      dispatch(onFetchShowQaInformationAction(data));
    },
    onFetchUpdateQaInformation: data => {
      dispatch(onFetchUpdateQaInformationAction(data));
    },
    onFetchDeleteQaInformation: data => {
      dispatch(onFetchDeleteQaInformationAction(data));
    },
    clearQaInformation: data => {
      dispatch(clearQaInformationAction(data));
    },
    onFetchIndexQaCategory: data => {
      dispatch(onFetchIndexQaCategoryAction(data));
    },
  };
};

const FormInit = connect(
  mapStateToProps,
  mapDispatchToProps
)(Edit);

export default withCookies(withRouter(FormInit));